import { Observable, of, BehaviorSubject, Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { FavoriteAction } from '../lookup-displaytype';
import { LookupGridComponent } from '../lookup-grid.component';

export interface SelectionState {
    selecteditems: any[];
    favoriteItems: any[];
    quickItems: any[];
}

export class LookupSelectionService {

    private state: SelectionState = {
        selecteditems: [],
        favoriteItems: [],
        quickItems: []
    };

    state$: BehaviorSubject<SelectionState> = new BehaviorSubject(this.state);

    selected$: Observable<any[]> = this.state$.pipe(
        switchMap(n => of(n.selecteditems))
    );

    favoriteItems$: BehaviorSubject<any> = new BehaviorSubject({items: this.state.favoriteItems, action: null });

    quickItems$: Observable<any[]> = this.state$.pipe(
        switchMap(n => of(n.quickItems))
    );

    selectionChanged$ = new Subject();

    private get idField() {
        return this.ins.idField;
    }

    constructor(private ins: LookupGridComponent) {
    }

    initFavoriteItems(items: any[]) {
        this.state.favoriteItems = items || [];
    }


    //#region æ¶èæ°æ®

    updateFavoriteData(data: any, action: FavoriteAction) {

        if (this.ins.savingFaoriteData) {
            return;
        }

        if (action === FavoriteAction.add) {
            this.state.favoriteItems = this.state.favoriteItems.concat([data]);
        } else {
            this.state.favoriteItems = this.state.favoriteItems.filter(n => n[this.idField] !== data[this.idField]);
        }

        this.favoriteItems$.next({ items: this.state.favoriteItems, action, data });
    }

    //#endregion

    //#region å¤éæ°æ®

    loadSelections( data: []) {
        this.state.selecteditems = [...data];
        this.state$.next(this.state);
    }

    getSelections() {
        return [...this.state.selecteditems];
    }

    select(item: any) {
        if (item) {
            this.state.selecteditems = [...this.state.selecteditems, item];
            this.state$.next(this.state);

            this.selectionChanged$.next({ data: [item[this.idField]], selected: true });
        }
    }

    unselectByPathcode(pathcode: string) {
        const ids = [];
        this.state.selecteditems = this.state.selecteditems.filter(n => {
            const _pathcode = this.ins.getPathCode(n, this.ins.treeInfo);
            const r = _pathcode && _pathcode.indexOf(pathcode) !== 0;
            if (!r) {
                ids.push(n[this.idField]);
            }
            return r;
        });
        // tfs 729663
        this.state$.next(this.state);
        this.selectionChanged$.next({ data: ids, selected: false });
    }

    updateSelections(data: any, checked = true) {

        if (!Array.isArray(data)) {
            data = [data];
        }

        const items = [ ...data ];
        const idField = this.idField;
        const ids = items.map(r => r[idField]);

        let selectionMap = new Map();
        if (this.state.selecteditems && this.state.selecteditems.length) {
            selectionMap = new Map(this.state.selecteditems.map<[string, any]>(n => [n[idField], n]));
        }

        if (checked) {
            if (this.state.selecteditems && !this.state.selecteditems.length) {
                this.state.selecteditems = items;
            } else {
                const itemsMap = new Map(items.map<[string, any]>(n => [n[idField], n]));
                const currentValues = this.state.selecteditems.map(n => {
                    return n[idField];
                });

                currentValues.push(...ids);

                this.state.selecteditems = Array.from(new Set(currentValues)).map(n => {
                    return selectionMap.get(n) || itemsMap.get(n);
                });
                // this.state.selecteditems.push(...newSelecedIds.map(n => ids[n]));

                // ids.forEach((n, i) => {
                //     if (!this.state.selecteditems.find(r => r[idField] == n)) {
                //         this.state.selecteditems.push(items[i]);
                //     }
                // });
            }
        } else {
            if (data) {
                ids.forEach(n => {
                    selectionMap.delete(n);
                })

                this.state.selecteditems = Array.from(selectionMap.values());
            }
        }

        this.state$.next(this.state);
        this.selectionChanged$.next({ data: ids, selected: checked });
    }

    unSelect(id: any) {
        if (id) {
            if (Array.isArray(id)) {
                // this.state.selecteditems = this.state.selecteditems.filter(n => {
                //     return id.indexOf(n[this.idField]) === -1;
                // });

                const selectedItemsMap = new Map<string, any>(this.state.selecteditems.map<[string, any]>(n => [n[this.idField], n]));
                id.forEach(n => {
                    selectedItemsMap.delete(n);
                });

                this.state.selecteditems = Array.from(selectedItemsMap.values());


                this.selectionChanged$.next({ data: id, selected: false });
            } else {
                this.state.selecteditems = this.state.selecteditems.filter(n => n[this.idField] != id);
                this.selectionChanged$.next({ data: [id], selected: false });
            }

            this.state$.next(this.state);
        }
    }

    clearSelections() {
        this.state.selecteditems = [];
        this.state$.next(this.state);
    }

    //#endregion

}
